import { render } from "./General_Bills.vue?vue&type=template&id=96a4f050&scoped=true"
import script from "./General_Bills.vue?vue&type=script&lang=js"
export * from "./General_Bills.vue?vue&type=script&lang=js"

import "./General_Bills.vue?vue&type=style&index=0&id=96a4f050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a4f050"]])

export default __exports__